import React, { useState, useEffect, useRef } from 'react';
import './productDetail.css';
import GiftImg from '../../assets/images/gift-img2.svg';
import Form from 'react-bootstrap/Form';
import { BreadCrumb } from 'primereact/breadcrumb';
import Footer from '../../layout/footer/footer';
import Beard from '../../assets/images/logo-beard.svg';
import Info from '../../assets/icons/info.svg';
import { useLocation } from "react-router-dom";
import ProductItems from "../../components/productsItem/products-items"
import { getProductsById, imgBaseUrl, addToBasket, getBasketList,setCountBasketList, deleteFromBasket } from '../../utils/api';
import EmptyCard from '../../assets/images/empty-card.svg';
import { Toast } from 'primereact/toast';
import Color from '../../assets/icons/color.svg'
import { useCart } from '../../contexts/CartContext';
import { Sidebar } from 'primereact/sidebar';
import ArrowDown from '../../assets/icons/select-arrow-down.svg'
import { CirclePicker } from 'react-color';
import Check from '../../assets/icons/check.svg'
import Select, { components } from 'react-select';
import useToastNotification from '../../hooks/useToastNotification';

function ProductDetail() {
    const toast = useRef(null);
    const [product, setProduct] = useState('');
    const location = useLocation();
    const canvasRef = useRef(null);
    const [isCanvasReady, setIsCanvasReady] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const colorInputRef = useRef(null);
    const { addToCart } = useCart();

    const sentViewRef = useRef(null); // ✅ جلوگیری از ارسال تکراری view_item
    // تنظیمات متن
    const [text, setText] = useState("");
    const [isAddBasket, setIsAddBasket] = useState(false);
    const [quantity, setQuantity] = useState(0);
    const [colorsPicker, setColorsPicker] = useState(['#FFFFFF', '#000000', '#58647A', '#63C6C3', '#B9D546', '#FFF56D', '#FF0000']);
    const [size, setSize] = useState({
        value: '',
        label: 'انتخاب کنید'
    });
    const [visiblePrepeardTexts, setVisiblePrepeardTexts] = useState(false);
    const [visibleFont, setVisibleFont] = useState(false);
    const [visibleSize, setVisibleSize] = useState(false);
    const { showError, showSuccess } = useToastNotification();
    const [customeCheck, setCustomCheck] = useState(false)
    const [basketList, setBasketList] = useState([])

    const handleChange = (event) => {
        setCustomCheck(event.target.checked);
        if (!event.target.checked) {
            setText('')
            setSize({
                value: '',
                label: 'انتخاب کنید'
            })
            setFont({
                value: '',
                label: 'انتخاب کنید'
            })
        }
    };
    const prepeardTexts = [
        "آرزوی بهترین هارو برایت دارم",
        "آمدی تا زمینم را آسمان کنی",
        "آیینه ی تمام نمای عشق، روزت مبارک",
        "با آرزوی اقبالی خوش",
        "با آرزوی بهترین موفقیت ها",
        "با تشکر از زحمات شما",
        "با نوید سلامتی و آرزوی تندرستی",
        "بماند به یادگار، به طراوت و به سادگی",
        "پدرم تولدت مبارک",
        "پدرم روزت مبارک",
        "پیوندتان مبارک ",
        "تبریک دست خالی مارا با سخاوت بی حدت بپذیر",
        "تقدیم برای سپاس از زحمات بی دریغ شما",
        "تقدیم به آنی که بهشت زیر پایش جای دارد",
        "تقدیم به زیباترین هدیه خداوند بر روی زمین",
        "تقدیم به مرد تمام روزهای زندگیم",
        "تقدیم به وجود پر مهرت",
        "تولدت مبارک",
        "تویی آن که خیزد از وی همه خرمی و سبزی ",
        "جهان کوچک من از تو زیباست",
        "ثانیه های زندگیت سرشار از شادی",
        "ثانیه ثانیه های زندگیتان سرشار از شادی",
        "دوستت دارم",
        "دیدگانت همیشه شاد",
        "حلول ماه مبارک رمضان مبارک",
        "دیدگانت همیشه شاد",
        "روز پاسدار مبارک ",
        "روز پدر بر شما مبارک باد",
        "روز پرستار مبارک",
        "روز پزشک مبارک",
        "روز جوان مبارک",
        "روز خبرنگار مبارک",
        "روز دانشجو مبارک",
        "روز دختر مبارک",
        "روز زن مبارک",
        "روز کارگر مبارک",
        "روز مادر بر شما مبارک باد",
        "روز مرد مبارک",
        "روز معلم مبارک",
        "عید سعید فطر مبارک",
        "مادرم تولدت مبارک",
        "مادرم روزت مبارک"
    ]


    const [sizes, setSizes] = useState([
        {
            value: 11,
            label: '11'
        },
        {
            value: 12,
            label: '12'
        },
        {
            value: 13,
            label: '13'
        },
        {
            value: 14,
            label: '14'
        },
        {
            value: 15,
            label: '15'
        },
        {
            value: 16,
            label: '16'
        },
        {
            value: 17,
            label: '17'
        },
        {
            value: 18,
            label: '18'
        },
        {
            value: 19,
            label: '19'
        },
        {
            value: 20,
            label: '20'
        },
        {
            value: 21,
            label: '21'
        },
        {
            value: 22,
            label: '22'
        },
        {
            value: 23,
            label: '23'
        },
        {
            value: 24,
            label: '24'
        },
        {
            value: 25,
            label: '25'
        },
        {
            value: 26,
            label: '26'
        },
        {
            value: 27,
            label: '27'
        },
        {
            value: 28,
            label: '28'
        },
        {
            value: 29,
            label: '29'
        },
        {
            value: 30,
            label: '30'
        },
        {
            value: 31,
            label: '31'
        },
        {
            value: 32,
            label: '32'
        },
        {
            value: 33,
            label: '33'
        },
        {
            value: 34,
            label: '34'
        },
        {
            value: 35,
            label: '35'
        },
        {
            value: 40,
            label: '40'
        },
        {
            value: 41,
            label: '41'
        },
        {
            value: 42,
            label: '42'
        },
        {
            value: 43,
            label: '43'
        },
        {
            value: 44,
            label: '44'
        },
        {
            value: 45,
            label: '45'
        }
    ])

    const [font, setFont] = useState({
        value: '',
        label: 'انتخاب کنید'
    });
    const [fonts, setFonts] = useState([{
        value: 'shabnam-medium',
        label: 'شبنم'
    },
    {
        value: 'IRANSans',
        label: 'ایران سنس'
    },
    {
        value: 'iran-yekan-medium',
        label: 'ایران یکان'
    }

    ]);
    const [color, setColor] = useState("#000000");
    const [position, setPosition] = useState({ x: 100, y: 100 });

    const getproductsById = async (Id, basketList) => {
        try {
            let res = await getProductsById(Id);
            let productData = res.data.data;
    
            // بررسی کنید که آیا محصول در سبد خرید وجود دارد
            const foundItem = basketList.find(item => item.productId == productData.id);
    
            if (foundItem) {
                //console.log(foundItem);
                setProduct(prevContent => ({
                    ...prevContent,
                    ...productData, // داده‌های محصول
                    basketId: foundItem.basketId,
                    count: foundItem.count
                }));
    
                setQuantity(foundItem.count);
                setIsAddBasket(true);
            } else {
                setProduct(productData);
            }
    
            //console.log('...', product);
        } catch (error) {
            console.error("خطا در دریافت محصول:", error);
        }
    };
    

  
    const customStyles = {
        default: {


            swatches: {
                display: "none",
            },
        },
    };

    useEffect(() => {
     
    }, [font, size])
    useEffect(() => {
        const fetchBasketAndProduct = async () => {
            console.log(111)
            let res = await getBasketList(localStorage.getItem('clientId'));
            let basketData = res.data.data;
            setBasketList(basketData);
    
            const queryParams = new URLSearchParams(location.search);
            const Id = queryParams.get("productId");
    
            if (Id) {
                getproductsById(Id, basketData);
            }
        };
    
        fetchBasketAndProduct();
    }, [location.search]);
    
     // ✅ ارسال رویداد GA4 وقتی صفحه جزئیات محصول باز می‌شود
  useEffect(() => {
    if (!product || !product.id || typeof window.gtag !== 'function') return;
    if (sentViewRef.current === product.id) return;

    const price = Number(product.price) || 0;
//alert(product.price);
    window.gtag('event', 'view_item', {
      currency: 'IRT',
      value: product.price,
      items: [
        {
          item_id: String(product.id),
          item_name: product.title || '',
          item_category: product.categotyTitle || '',
          item_category2: product.categotyId ? String(product.categotyId) : undefined,
          price: String(product.price)
        }
      ],
      page_type: 'product_detail'
    });

    sentViewRef.current = product.id;
  }, [product]);
    
    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };
    const getYOffset = () => {
        const screenWidth = window.innerWidth;

        // تنظیم مقدار yOffset بر اساس عرض صفحه
        if (screenWidth <= 900) {
            return 140; // مقدار برای موبایل
        } else {
            return 140; // مقدار برای دسکتاپ
        }
    };
    useEffect(() => {
        if (!product) return;

        const renderCanvas = async () => {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext("2d");

            try {
                // Fetch image as Base64 to prevent tainting issues
                const imageBase64 = await fetchImageAsBase64(product.imageUrl ? imgBaseUrl + product.imageUrl : EmptyCard);

                const img = new Image();
                img.src = imageBase64;

                img.onerror = (e) => {
                    console.error('Error loading image:', e);
                    img.onerror = null; // Prevent infinite loop
                    img.src = EmptyCard; // Fallback to default image
                };

                const yOffset = getYOffset();

                // Wait until image is loaded
                setIsCanvasReady(false);
                img.onload = () => {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    //console.log(size, `${size.value}px ${font.value}`)
                    // Draw text over the image
                    const fontSize = size.value ? size.value : '40';  // اندازه فونت
                    const fontFamily = font.value ? font.value : 'iran-yekan-medium';
                    ctx.font = `${fontSize}px ${fontFamily}`;
                    ctx.fillStyle = color;
                    ctx.textAlign = "center";

                    // Determine border color based on text color
                    const borderColor = color.toLowerCase() === "#ffffff" || color.toLowerCase() === "white" ? "black" : "white";
                    ctx.lineWidth = 4; // Border width
                    ctx.strokeStyle = borderColor; // Border color

                    const x = canvas.width / 2;
                    const y = canvas.height - yOffset; // Adjust position using yOffset

                    // Draw border (stroke) around the text
                    ctx.strokeText(text, x, y);

                    // Draw the actual text
                    ctx.fillText(text, x, y);

                    // Mark canvas as ready after successful draw
                    setIsCanvasReady(true);
                };
            } catch (error) {
                console.error("Failed to load image", error);
            }
        };

        renderCanvas();
    }, [product, text, size, font, color]);


    // Helper: wait for canvas readiness (image drawn) to avoid black images
    const waitForCanvasReady = (timeoutMs = 3000) => new Promise((resolve, reject) => {
        const start = Date.now();
        const check = () => {
            const canvas = canvasRef.current;
            if (isCanvasReady && canvas && canvas.width > 0 && canvas.height > 0) {
                resolve(true);
                return;
            }
            if (Date.now() - start > timeoutMs) {
                // Do not throw; signal not ready to allow fallback path
                resolve(false);
                return;
            }
            setTimeout(check, 50);
        };
        check();
    });

    // Convert the canvas image (with text overlay) to a Base64-encoded image URL
    const saveImageWithText = async () => {
        try {
            await waitForCanvasReady();
        } catch (e) {
            console.warn('Proceeding without confirmed canvas readiness:', e?.message || e);
        }
        const canvas = canvasRef.current;
        if (!canvas || !canvas.width || !canvas.height) return '';
        const imageDataUrl = canvas.toDataURL("image/png", 1.0); // Convert canvas to Base64-encoded image
        return imageDataUrl.replace(/^data:image\/png;base64,/, ''); // Remove the prefix
    };

    // Compose an offscreen image with text overlay (fallback when canvas not ready)
    const composeWithText = async (baseImageDataUrl) => {
        return await new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                try {
                    const c = document.createElement('canvas');
                    const ctx = c.getContext('2d');
                    c.width = img.width;
                    c.height = img.height;
                    ctx.drawImage(img, 0, 0, c.width, c.height);

                    const yOffset = getYOffset();
                    const fontSize = (size && typeof size === 'object' && size.value) ? size.value : '40';
                    const fontFamily = (font && typeof font === 'object' && font.value) ? font.value : 'iran-yekan-medium';
                    ctx.font = `${fontSize}px ${fontFamily}`;
                    ctx.fillStyle = color;
                    ctx.textAlign = 'center';
                    const borderColor = color && (color.toLowerCase() === '#ffffff' || color.toLowerCase() === 'white') ? 'black' : 'white';
                    ctx.lineWidth = 4;
                    ctx.strokeStyle = borderColor;
                    const x = c.width / 2;
                    const y = c.height - yOffset;
                    if (text) {
                        ctx.strokeText(text, x, y);
                        ctx.fillText(text, x, y);
                    }
                    const out = c.toDataURL('image/png', 1.0).replace(/^data:image\/png;base64,/, '');
                    resolve(out);
                } catch (e) {
                    resolve(baseImageDataUrl.replace(/^data:image\/[^;]+;base64,/, ''));
                }
            };
            img.onerror = () => resolve(baseImageDataUrl.replace(/^data:image\/[^;]+;base64,/, ''));
            img.src = baseImageDataUrl;
        });
    };

    // Returns prepared Base64 (no prefix) either from canvas or composed fallback
    const getPreparedImage = async () => {
        const ready = await waitForCanvasReady(6000);
        if (ready) {
            const img = await saveImageWithText();
            if (img) return img;
        }
        const base = await fetchImageAsBase64(product?.imageUrl ? imgBaseUrl + product.imageUrl : EmptyCard);
        return await composeWithText(base);
    };

    const saveToLocalStorage = async (updatedQuantity) => {

        const imageWithText = await getPreparedImage(); // Robust: waits or composes fallback
        const newProductData = {
            productId: product.id,                  // Product ID
            name: product.title,              // Product name
            price: totalPrice(product.price),            // Product price
            imageBase64: imageWithText,         // New Base64 image with text
            count: updatedQuantity,
            fontSize: typeof size === 'object' && Object.keys(size).length > 0
                ? (size.label === 'انتخاب کنید' ? 0 : parseInt(size.label))
                : parseInt(size),

            font: typeof font === 'object' && Object.keys(font).length > 0
                ? (font.label === 'انتخاب کنید' ? '' : font.label)
                : font,
            fontColor: color,
            cardText: text,
            isCustom : customeCheck,
            clientId: localStorage.getItem('clientId')
        };


        let res = await addToBasket(newProductData)
        let p = await appProducts(res.data.data)
        addToCart()

        // ✅ ارسال ایونت به Google Analytics 4
  if (product && typeof window.gtag === 'function') {
    const price = Number(product.price) || 0;

    window.gtag('event', 'add_to_cart', {
      currency: 'IRR',
      value: product.price,
      items: [
        {
          item_id: String(product.id),
          item_name: product.title || '',
          item_category: product.categotyTitle || '',
          item_category2: product.categotyId ? String(product.categotyId) : undefined,
          price: product.price,
          quantity: updatedQuantity
        }
      ],
    });
  }
    };
    const appProducts = async (products) => {
        products.map(item => {

            setProduct(prevContent => ({
                ...prevContent,
                basketId: item.basketId,
                count: item.count

            }))});
    }
    const changeCountProduct = async (updatedQuantity, product) => {
        try {
            //console.log(product)
            let pay = {
                clientId : localStorage.getItem('clientId'),
                basketId: product.basketId,
                count: updatedQuantity
            }
            let res =await setCountBasketList(pay)
            addToCart()
            //console.log(res)

        } catch (error) {
            
        }

    }

    const changeQuantityByTextInput = (val) => {
        if(val <= 5000 && val > 0)
        {
            setQuantity(val);
            if (quantity >= 1) {
                setQuantity(prevQuantity => {
                    const updatedQuantity = prevQuantity;
                    changeCountProduct(updatedQuantity, product); // Save with new quantity
                    return updatedQuantity;
                });
            }
        }
    
    }
    const changeQuantity = async (action) => {
        //console.log(action)
        if (action === 'add') {
            if (quantity >= 1) {
                setQuantity(prevQuantity => {
                    const updatedQuantity = prevQuantity + 1;
                    changeCountProduct(updatedQuantity, product); // Save with new quantity
                    return updatedQuantity;
                });
            } else {
                if (isSaving) return;
                setIsSaving(true);
                try {
                    const updatedQuantity = (quantity || 0) + 1;
                    setQuantity(updatedQuantity);
                    await saveToLocalStorage(updatedQuantity); // Save with new quantity
                } finally {
                    setIsSaving(false);
                }
            }
        }
        else if (action === 'minus') {
            if (quantity > 1) {
                setQuantity(prevQuantity => {
                    const updatedQuantity = prevQuantity - 1;
                    changeCountProduct(updatedQuantity, product); // Save with new quantity
                    return updatedQuantity;
                });
            } else {
                setIsAddBasket(false);
                removeFromCart(product.id,product.basketId); // Remove item if quantity is zero
            }
        }
    };

    const handleAddToBasket = async () => {
        if (isSaving) return;
        setIsSaving(true);
        let message = {
            text: 'کارت با موفقیت به سبد اضافه شد.'
        }
        showSuccess(message)
        setIsAddBasket(true);
        await saveToLocalStorage(quantity > 0 ? quantity : 1); // Save product to cart with quantity
        setQuantity(quantity > 0 ? quantity : 1);
        setIsSaving(false);
    };

    // Helper function to remove product from cart
    const removeFromCart = async (count,basketId) => {
        try {
            let pay = {
                count: count,
                basketId: basketId,
                clientId: localStorage.getItem('clientId')
            }
            let res = await deleteFromBasket(pay)
            if(res.data.isSuccess){
                showSuccess('محصول مورد نظر از سبد خرید حذف شد.')
                addToCart()
            }else{
                showSuccess(res.data.message)
            }
        } catch (error) {

        }
    };
    const items = [{ label: 'کادونا' }, { label: 'دسته بندی ها' }, { label: product.categotyTitle }];



    const [displayPicker, setDisplayPicker] = useState(false);

    const handleIconClick = () => {
        setDisplayPicker(!displayPicker); // نمایش یا مخفی کردن انتخابگر
        setTimeout(() => {
            const whiteCircle = document.querySelector('[title="#FFFFFF"]');

            if (whiteCircle) {
                whiteCircle.style.border = '2px solid #000'; // اضافه کردن بوردر مشکی
                whiteCircle.style.borderRadius = '50%'; // گرد کردن بوردر
            }
        }, 0);
    };

    const handleChangeComplete = (color) => {
        setColor(color.hex); // به‌روزرسانی رنگ انتخاب‌شده
    };

    const options = prepeardTexts.map((text) => ({ value: text, label: text }));
    const sizeOptions = sizes.map((text) => ({ value: text, label: text }));

    const CustomDropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.8527 9.64582C18.0484 9.84073 18.0489 10.1573 17.854 10.3529L12.389 15.8374C12.1741 16.0531 11.8248 16.0531 11.6098 15.8374L6.14484 10.3529C5.94993 10.1573 5.95049 9.84073 6.1461 9.64582C6.34171 9.4509 6.65829 9.45147 6.85321 9.64708L11.9994 14.8117L17.1456 9.64708C17.3406 9.45147 17.6571 9.4509 17.8527 9.64582Z" fill="#668CFF" />
                </svg>

            </components.DropdownIndicator>
        );
    };
    const customSelectStyles = {
        option: (provided) => ({
            ...provided,
            fontSize: "14px", // Customize font size here
            padding: "10px",
            fontWeight: '400',  // Optional: Adjust padding for a better look
        }),
        control: (provided) => ({
            ...provided,
            fontSize: "14px", // Change font size for the selected option box
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: "14px", // Change font size for the currently selected value
        }),
        menu: (provided) => ({
            ...provided,
            fontWeight: '400', // تغییر اندازه فونت منوی کشویی
        }),
    };


    const handleSelectChange = (selected) => {
        setText(selected ? selected.label : ""); // تنظیم مقدار `text` با انتخاب یا حذف مقدار
    };
    const handleSize = (selected) => {
        setSize(selected ? selected : ""); // تنظیم مقدار `text` با انتخاب یا حذف مقدار
    };
    const handleTextChange = (e) => {
        const newValue = e.target.value;
        setText(newValue);

        // اگر مقدار خالی شد، انتخاب `Select` نیز خالی می‌شود

    };
    function convertToPersianNumbers(input) {
        const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        return input.replace(/\d/g, (digit) => persianDigits[digit]);
    }


    const totalPrice = (price) => {
        console.log('price')
        if (customeCheck) {
            let setting = localStorage.getItem('settings');
            let finalPrice = parseInt(JSON.parse(setting).customCardPrice) //parseInt(price) + parseInt(JSON.parse(setting).priceSefareshi)
            console.log(price)
            console.log(finalPrice)
            return finalPrice + price
        } else {
            console.log(price)
            return parseInt(price)
        }
    }
    return (
        <>
            <div style={{ position: 'fixed', top: 0, width: '100%', zIndex: 9999 }}>
                <Toast ref={toast} />
            </div>

            <div className='container p-0'>
                <BreadCrumb model={items} />
                <div>
                    <div className="bg-card p-4 ">
                        <h4 className='text-2xl web text-[#0033CC] text-right mb-3 font-bold f-bold'>{product.title}</h4>
                        <div className="flex justify-between align-items-center flex-revers gap-20 max-md:gap-5">
                            <div className=' w-1/2 max-lg:!w-full'>
                                <Form className='mt-4'>
                                    <div className="text-sm font-bold">
                                        <div className="mb-3 mx-3">

                                            <Form.Check
                                            disabled={isAddBasket}
                                                type="checkbox"
                                                label="شخصی سازی سفارش"
                                                checked={customeCheck}
                                                id="custome"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        {customeCheck && (
                                        
                                         <div className=" row">
                                            <Form.Group className="mb-3 col-12 col-md-5">
                                                <Form.Label>متن کارت</Form.Label>
                                                <Form.Control
                                                    disabled={isAddBasket || !customeCheck}
                                                    value={text}
                                                    onChange={handleTextChange}
                                                    type="text"
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-4 col-10 col-md-5 sample-text">
                                                <Form.Label>متن های آماده</Form.Label>
                                                {/* Select for mobile view */}
                                                <div className='mobile'>
                                                    <div className='input-icon '>
                                                        <Form.Control value={text}
                                                            onClick={(e) => {
                                                                e.preventDefault(); // جلوگیری از باز شدن لیست
                                                                setVisiblePrepeardTexts(true); // نمایش Sidebar
                                                            }}
                                                            disabled={isAddBasket || !customeCheck}
                                                            readOnly />
                                                        <img src={ArrowDown} alt="" />
                                                    </div>
                                                    <Sidebar
                                                        header="متن های آماده"
                                                        visible={visiblePrepeardTexts}
                                                        position="bottom"
                                                        onHide={() => setVisiblePrepeardTexts(false)}
                                                    >
                                                        <div className="prepared-text-options">
                                                            {prepeardTexts.map((item, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`prepared-text-item ${text === item ? 'selected' : ''}`}
                                                                    onClick={() => {
                                                                        setText(item);
                                                                        setVisiblePrepeardTexts(false); // Close sidebar on selection
                                                                    }}
                                                                    style={{
                                                                        padding: '10px',
                                                                        borderBottom: '1px solid #eee',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    {item}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Sidebar>
                                                </div>

                                                <Select
                                                    options={options}
                                                    value={text ? options.find((option) => option.label === text) : null} // سینک با `text`
                                                    onChange={handleSelectChange}
                                                    styles={customSelectStyles}
                                                    placeholder="انتخاب کنید"
                                                    className="web"
                                                    isDisabled={isAddBasket || !customeCheck}
                                                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                                                />

                                                {/* Select for web view */}
                                                {/* <Form.Select disabled={isAddBasket} size='sm' className="web" value={text} onChange={(e) => setText(e.target.value)} >
                    <option value='' selected hidden>انتخاب کنید</option>
                    {prepeardTexts.map((text, index) => (
                      <option key={index} value={text}>{text}</option>
                    ))}
                  </Form.Select> */}
                                            </Form.Group>


                                            <Form.Group className=' col-2 col-md-2 color-font' style={{ position: 'relative' }}>
                                                <Form.Label ></Form.Label>

                                                <div className='mt-2'>
                                                    {/* Hidden input */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'start',
                                                            gap: '10px',
                                                            justifyContent: 'start',
                                                            position: 'relative'
                                                        }}
                                                    >
                                                        {/* آیکون برای باز کردن SketchPicker */}
                                                        <div
                                                            className={`${isAddBasket || !customeCheck ? ' bg-[#e9ecef]' : 'bg-[#fff]'} input-icons justify-content-center`}

                                                            style={{ height: '44px', width: '44px', cursor: 'pointer' }}
                                                            onClick={handleIconClick}
                                                        >
                                                            <img
                                                                src={Color}
                                                                alt="color-preview"
                                                            />
                                                        </div>

                                                        {/* نمایش SketchPicker */}
                                                        {displayPicker && (
                                                            <div className='color-picker' style={{ position: 'absolute', zIndex: 2 }}>
                                                                <CirclePicker
                                                                    styles={customStyles}
                                                                    color={color}
                                                                    width={300}
                                                                    circleSize={24}
                                                                    colors={colorsPicker}
                                                                    onChangeComplete={handleChangeComplete}
                                                                />
                                                            </div>
                                                        )}
                                                        {displayPicker && (
                                                            <div
                                                                style={{
                                                                    position: 'fixed',
                                                                    top: '3em',
                                                                    left: 0,
                                                                    right: 0,
                                                                    bottom: 0,
                                                                    zIndex: 1,
                                                                }}
                                                                onClick={() => setDisplayPicker(false)} // بستن انتخابگر با کلیک خارج از آن
                                                            />
                                                        )}
                                                    </div>

                                                </div>
                                            </Form.Group>
                                        </div>
                                        )}

                                        {customeCheck && (
                                        <div className="row ">
                                            <Form.Group className="mb-3 col-12 col-md-5">
                                                <Form.Label>فونت</Form.Label>
                                                {/* Select for mobile view */}
                                                <div className='mobile'>
                                                    <div className="input-icon">
                                                        <Form.Control
                                                            value={font.label} // Use font (id) for control value
                                                            onClick={(e) => {
                                                                e.preventDefault(); // Prevent opening list
                                                                setVisibleFont(true); // Show Sidebar
                                                            }}
                                                            disabled={isAddBasket || !customeCheck}
                                                            readOnly
                                                        />
                                                        <img src={ArrowDown} alt="" />
                                                    </div>
                                                    <Sidebar
                                                        header="فونت"
                                                        visible={visibleFont}
                                                        position="bottom"
                                                        onHide={() => setVisibleFont(false)}
                                                    >
                                                        <div className="prepared-text-options">
                                                            {fonts.map((item, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`prepared-text-item ${font === item.value ? 'selected' : ''}`}
                                                                    onClick={() => {
                                                                        setFont(item); // Update font id
                                                                        setVisibleFont(false); // Close sidebar on selection
                                                                    }}
                                                                    style={{
                                                                        padding: '10px',
                                                                        borderBottom: '1px solid #eee',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    {item.label}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Sidebar>
                                                </div>

                                                <Select
                                                    options={fonts}
                                                    value={font}
                                                    onChange={(selected) => { setFont(selected) }}
                                                    styles={customSelectStyles}
                                                    placeholder="انتخاب کنید"
                                                    className='web'
                                                    isDisabled={isAddBasket || !customeCheck}
                                                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                                                />
                              
                                            </Form.Group>
                                            <Form.Group className="mb-3 col-12 col-md-5 ">
                                                <Form.Label>سایز</Form.Label>
                                                <div className='mobile'>
                                                    <div className='input-icon'>
                                                        <Form.Control value={size.label}
                                                            className='number'
                                                            disabled={isAddBasket || !customeCheck}
                                                            onClick={(e) => {
                                                                e.preventDefault(); // جلوگیری از باز شدن لیست
                                                                setVisibleSize(true); // نمایش Sidebar
                                                            }}
                                                            readOnly />
                                                        <img src={ArrowDown} alt="" />
                                                    </div>
                                                    <Sidebar
                                                        header="سایز"
                                                        visible={visibleSize}
                                                        position="bottom"
                                                        onHide={() => setVisibleSize(false)}
                                                    >
                                                        <div className="prepared-text-options">
                                                            {sizes.map((item, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`prepared-text-item ${size === item.value ? 'selected' : ''} number`}
                                                                    onClick={() => {
                                                                        setSize(item);
                                                                        setVisibleSize(false); // Close sidebar on selection
                                                                    }}
                                                                    style={{
                                                                        padding: '10px',
                                                                        borderBottom: '1px solid #eee',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    {item.label}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Sidebar>
                                                </div>
                                                <Select
                                                    options={sizes}
                                                    value={size}
                                                    onChange={(selected) => { setSize(selected) }}
                                                    styles={customSelectStyles}
                                                    placeholder="انتخاب کنید"
                                                    className='web'
                                                    isDisabled={isAddBasket || !customeCheck}
                                                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                                                />
                                            </Form.Group>
                                        </div>
                                        )}
                                    </div>

                                    <div className=' w-100 bg-[#E5ECFF] mt-3 rounded-lg d-flex align-items-center justify-content-between p-2 ml-5'>
                                        <div>
                                            <h5 className='number text-center color-primary text-2xl mb-0 font-semibold'>{totalPrice(product.price).toLocaleString()} تومان</h5>
                                            {/* <h5 className='text-xl text-center number mb-0' style={{ color: '#B8B8B8', textDecoration: 'line-through' }}>50,000</h5> */}
                                        </div>
                                        {isAddBasket ? (


                                            <div className=" bg-[#fff] px-[8px]   py-1 border-[1px] border-blue flex items-center justify-between w-[176.5px] h-[48px] font-bold rounded">
                                                <div className='cursor-pointer' onClick={() => changeQuantity('add')}>
                                                    <img src={require('../../assets/icons/basket/add.svg').default} alt="" />
                                                </div>
                                                <div className='number'>
                                                    
                                                    <input
                                                    value = {quantity}
                                                    min="1"
                                                    max="5000"
                                                    type='number'
                                                    className='text-center border-none outline-none'
                                                    onChange={(e) => changeQuantityByTextInput(Number(e.target.value))}
                                                    />
                                                    </div>
                                                <div className='cursor-pointer' onClick={() => changeQuantity('minus')}>
                                                    {quantity === 1 ? (
                                                        <img src={require('../../assets/icons/basket/trash.svg').default} alt="" width={24} />
                                                    ) : (
                                                        <img src={require('../../assets/icons/basket/minus.svg').default} alt="" width={24} />
                                                    )}
                                                </div>
                                            </div>

                                        ) : (
                                            <button className='btn btn-primary shop-btn w-[176.5px] h-[48px]' type='button' onClick={handleAddToBasket} disabled={isSaving}>
                                                افزودن به سبد
                                            </button>
                                        )}
                                    </div>

                                    <div className='d-flex gap-2 mt-4 align-items-start'>
                                        <img src={Info} alt="" />
                                        <div>
                                            <h6 className='text-[#0033CC] text-sm'>حداکثر مبلغ شارژ کارت هدیه 5 میلیون تومان می‌باشد.</h6>
                                            <h6 className='text-[#0033CC] text-sm'>
                                                {
                                                    convertToPersianNumbers('کارت شارژ شده، پس از 48 ساعت فعال و قابل استفاده خواهد بود.')
                                                }
                                            </h6>
                                        
                                            
                                            {/* <h6 className='alert alert-danger f-bold'>
                                                    سفارشاتی که از تاریخ 1403/12/19 در سامانه ثبت شوند ، ارسال آنها از تاریخ 1404/01/06 به بعد انجام میگردد
                                            </h6> */}
                                        </div>
                                    </div>
                                </Form>
                            </div>
                            <div className='convas-img'  >
                                <canvas className='' ref={canvasRef} style={{ width: '100%', borderRadius: '24px' }} />
                            </div>

                        </div>
                    </div>
                </div >

                <div className='bg-slider bg-no-repeat bg-left-top bg-contain mt-5 mb-5'>
                    <div className='d-flex align-items-center text-2xl  text-[#0033CC] f-bold gap-3 text-2xl justify-content-start' style={{ fontSize: '24px' }}>
                        <img src={Beard} alt="" style={{ display: 'block' }} />محصولات مشابه
                    </div>
                    <div className='px-5'>

                        <ProductItems categoryId={product.categotyId} />
                    </div>
                </div>
            </div >

            <div className="home-footer mt-40">
                <Footer />
            </div>
        </>
    );
}

export default ProductDetail;
